const INACTIVE_STATUSES = new Set(['canceled', 'cancelled', 'incomplete_expired'])

/**
 * Normalizes the `/billing/subscriptions/me/` payload into the bits the UI needs.
 * Returns null when there's nothing loaded yet so callers can stay neutral
 * instead of flashing "Grátis"; an inactive subscription degrades to free.
 */
export function derivePlan(data) {
  if (!data) return null
  const status = String(data?.subscription?.status || '').toLowerCase()
  const plan = INACTIVE_STATUSES.has(status)
    ? null
    : data?.plan || data?.subscription?.plan || null
  const isPaid = !!plan && !plan.is_free && Number(plan?.price_cents || 0) > 0
  return {
    isPaid,
    name: isPaid ? plan?.name || 'Plano' : 'Grátis',
    // Expostos p/ a seleção de upgrade das ofertas de uso (usageOffers.js):
    // preço atual decide o "próximo tier", uuid faz o deep-link, limite alimenta a copy.
    priceCents: isPaid ? Number(plan?.price_cents) || 0 : 0,
    planUuid: isPaid ? plan?.uuid || null : null,
    weeklyLimit: Number(plan?.weekly_message_limit) || 0,
  }
}
